import React, { Component } from 'react';

export class Integritetspolicy extends Component {
    static displayName = Integritetspolicy.name;

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div>
                <div className="page-header">
                    <div className="row">
                        <div className="col-md-12 noPadding">
                            <h1>Integritetspolicy</h1>
                            <p><em>Senast uppdaterad: 2026-03-06</em></p>

                            <h4>1. Vem ansvarar f&ouml;r dina personuppgifter?</h4>
                            <p>
                                Eurostar AB (&quot;vi&quot;, &quot;oss&quot;, &quot;v&aring;r&quot;) &auml;r personuppgiftsansvarig f&ouml;r behandlingen av dina personuppgifter.
                                Om du har fr&aring;gor om hur vi hanterar dina uppgifter &auml;r du v&auml;lkommen att kontakta oss via din lokala biograf.
                            </p>

                            <h4>2. Vilka personuppgifter samlar vi in?</h4>
                            <p>N&auml;r du registrerar dig som medlem samlar vi in:</p>
                            <ul>
                                <li><strong>E-postadress</strong> &ndash; f&ouml;r inloggning och kommunikation</li>
                                <li><strong>Telefonnummer</strong> &ndash; f&ouml;r att koppla bokningar till ditt konto (valfritt)</li>
                                <li><strong>L&ouml;senord</strong> &ndash; lagras krypterat (hashat) och kan inte l&auml;sas av n&aring;gon</li>
                                <li><strong>Vald ort</strong> &ndash; f&ouml;r att visa relevant biograf och filmprogram</li>
                            </ul>
                            <p>Vi samlar &auml;ven in:</p>
                            <ul>
                                <li><strong>Bokningshistorik</strong> &ndash; information om vilka filmer du har bokat biljetter till</li>
                                <li><strong>Utskicksinst&auml;llningar</strong> &ndash; dina val g&auml;llande nyhetsbrev och filmrekommendationer</li>
                                <li><strong>Genrepreferenser</strong> &ndash; vilka filmgenrer du &auml;r intresserad av</li>
                            </ul>

                            <h4>3. Varf&ouml;r behandlar vi dina personuppgifter?</h4>
                            <p>Vi behandlar dina personuppgifter f&ouml;r f&ouml;ljande &auml;ndam&aring;l:</p>
                            <ul>
                                <li>Hantera ditt medlemskonto och inloggning</li>
                                <li>M&ouml;jligg&ouml;ra biljettbokning och bokningshantering</li>
                                <li>Skicka nyhetsbrev, filmprogram och erbjudanden (baserat p&aring; dina inst&auml;llningar)</li>
                                <li>Anpassa filmrekommendationer utifr&aring;n dina genrepreferenser</li>
                                <li>Fullg&ouml;ra v&aring;ra r&auml;ttsliga skyldigheter</li>
                            </ul>

                            <h4>4. R&auml;ttslig grund f&ouml;r behandlingen</h4>
                            <ul>
                                <li><strong>Avtal</strong> &ndash; Behandlingen &auml;r n&ouml;dv&auml;ndig f&ouml;r att fullg&ouml;ra v&aring;rt avtal med dig (t.ex. hantera bokningar och konto)</li>
                                <li><strong>Samtycke</strong> &ndash; F&ouml;r utskick av nyhetsbrev och marknadsf&ouml;ring baserat p&aring; dina inst&auml;llningar</li>
                                <li><strong>Ber&auml;ttigat intresse</strong> &ndash; F&ouml;r att f&ouml;rb&auml;ttra v&aring;ra tj&auml;nster och anpassa din upplevelse</li>
                            </ul>

                            <h4>5. Hur l&auml;nge sparar vi dina uppgifter?</h4>
                            <p>
                                Vi sparar dina personuppgifter s&aring; l&auml;nge du &auml;r aktiv medlem. Om du v&auml;ljer att radera ditt
                                konto inaktiveras det omedelbart. Bokr&auml;kenskapsmaterial kan beh&aring;llas enligt lagstadgade krav.
                            </p>

                            <h4>6. Dina r&auml;ttigheter enligt GDPR</h4>
                            <p>Du har f&ouml;ljande r&auml;ttigheter:</p>
                            <ul>
                                <li><strong>R&auml;tt till tillg&aring;ng</strong> &ndash; Du kan exportera alla dina personuppgifter fr&aring;n &quot;Min profil&quot; p&aring; Mina Sidor</li>
                                <li><strong>R&auml;tt till r&auml;ttelse</strong> &ndash; Du kan uppdatera dina uppgifter (telefonnummer, e-post, l&ouml;senord) p&aring; Mina Sidor</li>
                                <li><strong>R&auml;tt till radering</strong> &ndash; Du kan radera ditt konto fr&aring;n &quot;Min profil&quot; p&aring; Mina Sidor</li>
                                <li><strong>R&auml;tt till begr&auml;nsning</strong> &ndash; Du kan n&auml;r som helst &auml;ndra dina utskicksinst&auml;llningar</li>
                                <li><strong>R&auml;tt till dataportabilitet</strong> &ndash; Du kan ladda ner dina uppgifter i maskinl&auml;sbart format (JSON)</li>
                                <li><strong>R&auml;tt att &aring;terkalla samtycke</strong> &ndash; Du kan n&auml;r som helst &aring;terkalla ditt samtycke till utskick</li>
                            </ul>

                            <h4>7. Cookies</h4>
                            <p>
                                Vi anv&auml;nder cookies f&ouml;r att lagra din valda ort och f&ouml;r att tj&auml;nsten ska fungera korrekt.
                                L&auml;s mer p&aring; v&aring;r sida <a href="/HurViAnvanderCookies">Hur vi anv&auml;nder cookies</a>.
                            </p>

                            <h4>8. Delning av uppgifter</h4>
                            <p>
                                Vi s&auml;ljer aldrig dina personuppgifter till tredje part. Dina uppgifter delas inte med
                                utomst&aring;ende f&ouml;retag utom n&auml;r det kr&auml;vs enligt lag.
                            </p>

                            <h4>9. S&auml;kerhet</h4>
                            <p>
                                Vi vidtar l&auml;mpliga tekniska och organisatoriska &aring;tg&auml;rder f&ouml;r att skydda dina personuppgifter.
                                L&ouml;senord lagras krypterade och &ouml;verf&ouml;ring av data sker via krypterad anslutning (HTTPS).
                            </p>

                            <h4>10. Kontakt och klagom&aring;l</h4>
                            <p>
                                Om du har fr&aring;gor om v&aring;r behandling av personuppgifter, kontakta oss via din lokala biograf
                                eller via de kontaktuppgifter som finns p&aring; sidan <a href="/OmEurostar">Om Eurostar</a>.
                            </p>
                            <p>
                                Du har &auml;ven r&auml;tt att l&auml;mna klagom&aring;l till Integritetsskyddsmyndigheten (IMY) om du anser att vi
                                behandlar dina personuppgifter p&aring; ett felaktigt s&auml;tt.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
